import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { ANNOTATION_USER_LOCATION } from '@appfolio/backstage-plugin-catalog-common';

const FACET = `metadata.annotations.${ANNOTATION_USER_LOCATION}`;

class EntityUserLocationFilter implements EntityFilter {
  public constructor(readonly values: string[]) {}

  public getCatalogFilters(): Record<string, string | string[]> {
    return { [FACET]: this.values };
  }

  public toQueryValue(): string[] {
    return this.values;
  }
}

export const EntityUserLocationPicker = () => (
  <EntityAutocompletePicker<
    DefaultEntityFilters & {
      userLocation: EntityUserLocationFilter;
    }
  >
    label="Location"
    name="userLocation"
    path={FACET}
    Filter={EntityUserLocationFilter}
  />
);
